// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://slbjqrqgbxdvcpjxgylr.supabase.co';
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_kKVz8WKMwdjjoeVW1ZjH9Q_XCrRioux';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
